export { BeforeAfterSection as BeforeAfterComparisonSection } from "../expanded-section-pack"